import type {
  CarePlanGetAllResponse,
  CarePlanSearchParams,
  CreateCarePlanRequest,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export const carePlanSWRKey = 'trpc/care-plan';

export class CarePlanApi {
  public getCarePlans = async (
    params: CarePlanSearchParams,
  ): Promise<CarePlanGetAllResponse> => {
    return await trpcClient.carePlan.getAll.query(params);
  };

  public createCarePlan = async (
    params: CreateCarePlanRequest,
  ): Promise<void> => {
    await trpcClient.carePlan.create.mutate(params);
  };
}
